import { AuthUserPerfilId } from "../store/modules/auth/IAuthUserPerfil";

export const allProfileIds: AuthUserPerfilId[] = [
  AuthUserPerfilId.AssessorAdmin,
  AuthUserPerfilId.AssessorConsulta,
  AuthUserPerfilId.AssessorGestao,
  AuthUserPerfilId.Associado,
  AuthUserPerfilId.AssociadoConvidado,
  AuthUserPerfilId.Deslogado
]

export const allAssessorProfileIds: AuthUserPerfilId[] = [
  AuthUserPerfilId.AssessorAdmin,
  AuthUserPerfilId.AssessorConsulta,
  AuthUserPerfilId.AssessorGestao,
]

export const allAssociadoProfileIds: AuthUserPerfilId[] = [
  AuthUserPerfilId.Associado,
  AuthUserPerfilId.AssociadoConvidado,
]